import { rem } from "polished";
import { ThemeKind } from "src/types";

import { ColorLabels } from "@/components/editor/utils/use-color";

import { createThemeFactory } from "../utils";
import preview from "./assets/preview.jpg";
import previewSmall from "./assets/preview-small.jpg";
import { colorSet, fonts } from "./constants";
import createTemplate from "./create-template";
import blocks from "./resolved-blocks";
import selections from "./selections";

export default createThemeFactory(() => ({
  kind: ThemeKind.CROSBY,
  name: "Crosby",
  categories: "University Events, Job Fairs, Expos/Tradeshows, Workshops",
  smallPreviewUrl: previewSmall,
  previewUrl: preview,
  previewColor: "#E5ECD6",
  blocks,
  selections,
  enabled: true,
  requiresPaymentPlanUpgrade: false,
  colorSet,
  fonts,
  typography: {
    patterns: {
      headingOne: {
        fontSize: rem(64),
        lineHeight: rem(72),
        fontWeight: 700,
        color: ColorLabels.PRIMARY_FONT,
        viewport: {
          mobile: {
            fontSize: rem(40),
            lineHeight: rem(52),
          },
        },
      },
      headingTwo: {
        fontSize: rem(32),
        lineHeight: rem(40),
        marginBottom: rem(40),
        fontWeight: 700,
        color: ColorLabels.PRIMARY_FONT,
        viewport: {
          mobile: {
            fontSize: rem(28),
            lineHeight: rem(34),
            marginBottom: rem(32),
          },
        },
      },
      headingThree: {
        fontSize: rem(24),
        lineHeight: rem(32),
        marginBottom: rem(8),
        fontWeight: 600,
        color: ColorLabels.PRIMARY_FONT,
        viewport: {
          mobile: {
            fontSize: rem(22),
          },
        },
      },
      headingFour: {
        fontSize: rem(20),
        fontWeight: 600,
        color: ColorLabels.PRIMARY_FONT,
        lineHeight: rem(32),
        marginBottom: rem(8),
      },
      paragraph: {
        fontSize: rem(18),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(33),
        viewport: {
          mobile: {
            fontSize: rem(16),
            lineHeight: rem(28),
          },
        },
      },
      bodyOne: {
        fontSize: rem(18),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(33),
        viewport: {
          mobile: {
            fontSize: rem(16),
            lineHeight: rem(28),
          },
        },
      },
      description: {
        fontSize: rem(14),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(26),
      },
      bodyTwo: {
        fontSize: rem(14),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(26),
      },
      labelOne: {
        fontSize: rem(16),
        fontWeight: 400,
        color: ColorLabels.PRIMARY_FONT,
        lineHeight: rem(32),
      },
      labelTwo: {
        fontSize: rem(14),
        fontWeight: 400,
        color: ColorLabels.SECONDARY_FONT,
        lineHeight: rem(32),
      },
    },
  },
  fontStyles: {
    headingOne: {
      fontSize: [rem(40), rem(64), rem(64)],
      fontWeight: 700,
      color: ColorLabels.PRIMARY_FONT,
      lineHeight: [rem(52), rem(72), rem(72)],
    },
    headingTwo: {
      fontSize: [rem(28), rem(32), rem(32)],
      fontWeight: 700,
      color: ColorLabels.PRIMARY_FONT,
      lineHeight: [rem(34), rem(40), rem(40)],
      marginBottom: [rem(32), rem(40), rem(40)],
    },
    headingThree: {
      fontSize: [rem(22), rem(24), rem(24)],
      fontWeight: 600,
      color: ColorLabels.PRIMARY_FONT,
      lineHeight: [rem(32), rem(32), rem(32)],
      marginBottom: [rem(8), rem(8), rem(8)],
    },
    headingFour: {
      fontSize: [rem(20), rem(20), rem(20)],
      fontWeight: 600,
      color: ColorLabels.PRIMARY_FONT,
      lineHeight: [rem(32), rem(32), rem(32)],
      marginBottom: [rem(8), rem(8), rem(8)],
    },
    paragraph: {
      fontSize: [rem(16), rem(18), rem(18)],
      fontWeight: 400,
      color: ColorLabels.SECONDARY_FONT,
      lineHeight: [rem(28), rem(33), rem(33)],
    },
    bodyOne: {
      fontSize: [rem(16), rem(18), rem(18)],
      fontWeight: 400,
      color: ColorLabels.SECONDARY_FONT,
      lineHeight: [rem(28), rem(33), rem(33)],
    },
    description: {
      fontSize: [rem(14), rem(14), rem(14)],
      fontWeight: 400,
      color: ColorLabels.SECONDARY_FONT,
      lineHeight: [rem(26), rem(26), rem(26)],
    },
    bodyTwo: {
      fontSize: [rem(14), rem(14), rem(14)],
      fontWeight: 400,
      color: ColorLabels.SECONDARY_FONT,
      lineHeight: [rem(26), rem(26), rem(26)],
    },
    labelOne: {
      fontSize: [rem(16), rem(16), rem(16)],
      fontWeight: 400,
      color: ColorLabels.PRIMARY_FONT,
      lineHeight: [rem(32), rem(32), rem(32)],
    },
    labelTwo: {
      fontSize: [rem(14), rem(14), rem(14)],
      fontWeight: 400,
      color: ColorLabels.SECONDARY_FONT,
      lineHeight: [rem(32), rem(32), rem(32)],
    },
  },
  createTemplate,
}));
